/*
  Wholey PDP-Upsell ("Pairs well with")
  Klick auf die Zeile öffnet das zentrale Produktdetail-Modal
  (loop-product-modal.js), der Button rechts legt das Produkt direkt in den
  Warenkorb und öffnet den Cart Drawer.
*/
(function () {
  'use strict';

  if (customElements.get('loop-product-upsell')) return;

  class LoopProductUpsell extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const add = event.target.closest('[data-upsell-add]');
      if (add) {
        this.addToCart(add.dataset.upsellAdd, 1, add);
        return;
      }

      const row = event.target.closest('[data-open-detail]');
      if (row) {
        const Modal = customElements.get('loop-product-modal');
        if (!Modal) return;
        Modal.getOrCreate().open(row.dataset.openDetail, {
          onAdd: (variantId, quantity) => this.addToCart(variantId, quantity),
        });
      }
    }

    showError(message) {
      const box = this.querySelector('[data-upsell-error]');
      if (box) {
        box.textContent = message;
        box.hidden = !message;
      }
    }

    async addToCart(variantId, quantity = 1, button = null) {
      if (this.loading) return;
      this.loading = true;
      button?.classList.add('is-loading');
      this.showError('');

      try {
        // Drawer-HTML direkt mitanfordern, wie das Produktformular des Themes
        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const response = await fetch(`${theme.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity }],
            sections: sectionsToBundle.join(','),
            sections_url: window.location.pathname,
          }),
        });
        if (!response.ok) {
          const json = await response.json().catch(() => ({}));
          throw new Error(json.description || `Add to cart failed: ${response.status}`);
        }
        const parsedState = await response.json();

        const drawer = document.querySelector('cart-drawer');
        if (!drawer) {
          window.location.href = theme.routes.cart_url;
          return;
        }

        // Drawer mit der frischen Section-HTML neu rendern lassen; Fehler der
        // Subscriber (z.B. a11y-Fokus) dürfen den erfolgreichen Add nicht kippen
        const cartJson = await fetch(theme.routes.cart_url, theme.utils.fetchConfig('json', 'GET')).then((r) =>
          r.json()
        );
        cartJson.sections = parsedState.sections;
        try {
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cart: cartJson });
        } catch (error) {
          console.warn('[product-upsell] cart update subscriber error', error);
        }

        drawer.show(button || undefined);
      } catch (error) {
        console.error('[product-upsell]', error);
        this.showError('Das Produkt konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
      } finally {
        this.loading = false;
        button?.classList.remove('is-loading');
      }
    }
  }

  customElements.define('loop-product-upsell', LoopProductUpsell);
})();
